export default function AboutUs() {
    return (
      <section id="about" className="bg-gray-200 py-16 px-4 md:px-20 font-sans">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          
          {/* Left: Text Content */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Story</h2>
            <p className="text-gray-600 mb-5 leading-relaxed">
              Started in 1987, by cloth traders who wanted to trade in construction hardware goods,
              seeing the development in the nation’s commercial and residential markets. Since then,
              we have served our purpose of fulfilling the needs of our customers by supplying quality
              products at the best price and at the right time.
            </p>
            <p className="text-gray-600 mb-5 leading-relaxed">
              Our focus is on supplying the products with best quality standards keeping in view the
              needs of the customer by offering budget friendly alternatives.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Today, Nishar Hardware is one of the most reputed establishments in the country, known
              for furniture fittings, designer hardware, architectural hardware, etc. All this was
              possible to achieve with the help from the Team of Nishar Hardware which works really
              hard to cater to the needs of its customers.
            </p>
          </div>
  
          {/* Right: Image with border/frame effect */}
          <div className="relative p-2 border-4 border-white">
            <img
              src="/SYNCRO PROFILE SLIDING DOORS.jpg" // Replace with your actual image path
              alt="Our Story"
              className="w-full object-cover"
            />
          </div>
        </div>
      </section>
    );
  }
  